import { render } from "./RouteWrapper.vue?vue&type=template&id=f4b35bde"
import script from "./RouteWrapper.vue?vue&type=script&lang=js"
export * from "./RouteWrapper.vue?vue&type=script&lang=js"

import "./RouteWrapper.vue?vue&type=style&index=0&id=f4b35bde&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__